import {AssetFinanceTier4} from '@portal-workspace/grow-shared-library';

export type AssetTier4Value = AssetFinanceTier4 | null;
